/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import PropTypes from 'prop-types';
import { Margin } from '../../common/base';
import { Grid, Col } from '../../common/interfaces';
import {
  TeamImg,
  TeamInfoBox,
  TeamInfoCard,
  TeamInfoSocial,
  TeamSubtitle,
  TeamInfoCardMobile,
  TeamInfoSocialMobile
} from './Styled';

class ListTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: 0
    };
  }

  handleExpand = index => {
    const { expanded } = this.state;
    const current = expanded === index ? expanded : index;
    this.setState(() => ({ expanded: current }));
  };

  teamInfo = () => {
    const { list, alignment } = this.props;
    const { expanded } = this.state;
    return (
      <TeamInfoBox alignment={alignment}>
        <TeamInfoCard>
          {list.map((member, index) => (
            <div key={index}>
              {expanded === index && (
                <div>
                  <h4>{member.name}</h4>
                  <TeamSubtitle>{member.position}</TeamSubtitle>
                  <TeamSubtitle>{member.alumni}</TeamSubtitle>
                  <TeamInfoSocial>
                    <a href={member.linkedin} target="blank">
                      <img src="../../../static/images/social/ic-linkedin-red.svg" alt="LinkedIn" />
                    </a>
                  </TeamInfoSocial>
                  <Margin top={40}>
                    {member.desc.split('\n').map((par, idx) => (
                      <p key={idx}>{par}</p>
                    ))}
                  </Margin>
                </div>
              )}
            </div>
          ))}
        </TeamInfoCard>
      </TeamInfoBox>
    );
  };

  teamImage = () => {
    const { list } = this.props;
    const { expanded } = this.state;
    return list.map((member, index) => (
      <TeamImg
        key={index}
        onClick={() => this.handleExpand(index)}
        activeStyle={expanded === index}
      >
        <img src={member.image} alt={`Photo of ${member.name}`} />
      </TeamImg>
    ));
  };

  teamListMobile = () => {
    const { list } = this.props;
    const { expanded } = this.state;
    return list.map((member, index) => (
      <Col key={index} lg="hidden" md={6}>
        <TeamImg onClick={() => this.handleExpand(index)} activeStyle={expanded === index}>
          <img src={member.image} alt={`Photo of ${member.name}`} />
        </TeamImg>
        {expanded === index && (
          <TeamInfoCardMobile activeStyleMobile={expanded}>
            <h4>{member.name}</h4>
            <TeamSubtitle>{member.position}</TeamSubtitle>
            <TeamSubtitle>{member.alumni}</TeamSubtitle>
            <TeamInfoSocialMobile activeStyleMobile={expanded}>
              <a href={member.linkedin} target="blank">
                <img
                  src="../../../static/images/social/ic-linkedin-red.svg"
                  alt="Icon - Linkedin"
                />
              </a>
            </TeamInfoSocialMobile>
            <Margin top={24}>
              <p>{member.desc}</p>
            </Margin>
          </TeamInfoCardMobile>
        )}
      </Col>
    ));
  };

  render() {
    const { alignment } = this.props;
    return (
      <Grid>
        {alignment === 'left' ? (
          <React.Fragment>
            <Col lg={6} md="hidden">
              {this.teamImage()}
            </Col>
            <Col lg={6} md="hidden">
              {this.teamInfo()}
            </Col>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Col lg={6} md="hidden">
              {this.teamInfo()}
            </Col>
            <Col lg={6} md="hidden">
              {this.teamImage()}
            </Col>
          </React.Fragment>
        )}
        {this.teamListMobile()}
      </Grid>
    );
  }
}

ListTeam.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      position: PropTypes.string.isRequired,
      alumni: PropTypes.string.isRequired,
      linkedin: PropTypes.string.isRequired,
      desc: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired
    })
  ).isRequired,
  alignment: PropTypes.oneOf(['left', 'right'])
};

ListTeam.defaultProps = {
  alignment: 'right'
};

export default ListTeam;
